import { Api, Rest, changeTheme } from "@/utils";
import ProfileConfig from '@/profileConfig.js';

const profile = new ProfileConfig();
changeTheme(profile.lightTheme ? 'light' : 'dark')

/**
 * @param {*} store 
 * @param {('favorites')|('lastVisited')} type 
 */
async function checkAndUpdateSlugs(store, type) {
  let articles = [...store.state[type]];
  let wasUpdated = false;
  let updateCount = 0;

  for (let article of articles) {
    // get up-to-date article from db
    const dbArticle = (await Rest.get('Article', {
      properties: { id: article.id }
    }))[0];
    // check if it needs an update
    if (article.slug !== dbArticle.slug) {
      const index = articles.findIndex(a => a.id === article.id);
      if (~index) {
        articles[index] = dbArticle;
        wasUpdated = true;
        updateCount++;
      }
    }
  }

  if (wasUpdated) {
    console.log('Updated', updateCount, type, 'slugs');
    if (type === 'favorites') store.commit('setFavorites', articles);
    else if (type === 'lastVisited') store.commit('setVisited', articles);
  }
}

export default {
  state: {
    loggedInUser: undefined,
    // user config
    langEng: profile.langEng || false,
    favorites: profile.favorites || [],
    lastVisited: profile.lastVisited || [],
    showEditorStyling: profile.showEditorStyling || false,
    editorFontSize: profile.editorFontSize || 1.2,
    lightTheme: profile.lightTheme || true,
  },
  getters: {
    isAdmin(state) {
      return state.loggedInUser && /root|admin|teacher|manager/.test(state.loggedInUser.roles)
    },
    isLiterallyAdmin(state) {
      return state.loggedInUser && /root|admin/.test(state.loggedInUser.roles)
    }
  },
  mutations: {
    setLoggedIn(state, val) {
      state.loggedInUser = val;
    },
    // user config
    addFavorite(state, article) {
      const index = state.favorites.findIndex(a => a.id === article.id);
      if (!~index) {
        state.favorites.unshift(article);
        profile.favorites = state.favorites;
        profile.save();
      }
    },
    removeFavorite(state, article) {
      const index = state.favorites.findIndex(a => a.id === article.id);
      if (~index) {
        state.favorites.splice(index, 1);
        profile.favorites = state.favorites;
        profile.save();
      }
    },
    setFavorites(state, favorites) {
      state.favorites = favorites;
      profile.favorites = state.favorites;
      profile.save();
    },
    increaseEditorFontSize(state) {
      state.editorFontSize += 0.1;
      profile.editorFontSize = state.editorFontSize;
      profile.save();
    },
    decreaseEditorFontSize(state) {
      state.editorFontSize -= 0.1;
      profile.editorFontSize = state.editorFontSize;
      profile.save();
    },
    addVisited(state, article) {
      const index = state.lastVisited.findIndex(a => a.id === article.id);
      if (~index) state.lastVisited.splice(index, 1);
      state.lastVisited.unshift(article);

      if (state.lastVisited.length > 5)
        state.lastVisited.pop();

      profile.lastVisited = state.lastVisited;
      profile.save();
    },
    removeVisited(state, article) {
      const index = state.lastVisited.findIndex(a => a.id === article.id);
      if (~index) {
        state.lastVisited.splice(index, 1);
        profile.lastVisited = state.lastVisited;
        profile.save();
      }
    },
    setVisited(state, visited) {
      state.lastVisited = visited;
      profile.lastVisited = state.lastVisited;
      profile.save();
    },
    toggleLanguage(state) {
      state.langEng = !state.langEng;
      profile.langEng = state.langEng;
      profile.save();
    },
    toggleEditorStyling(state) {
      state.showEditorStyling = !state.showEditorStyling;
      profile.showEditorStyling = state.showEditorStyling;
      profile.save();
    },
    toggleLightTheme(state) {
      state.lightTheme = !state.lightTheme;
      profile.lightTheme = state.lightTheme;
      profile.save();

      changeTheme(profile.lightTheme ? 'light' : 'dark')
    },
    initTheme(state) {
      state.lightTheme = profile.lightTheme
    }
  },
  actions: {
    /** Checks if there are any outdated slugs in localStorage, update those who are. */
    async updateArticleSlugs(store) {
      checkAndUpdateSlugs(store, 'favorites');
      checkAndUpdateSlugs(store, 'lastVisited');
    },
    async whoami(store) {
      // If already logged in
      if (this.loggedInUser) { return this.loggedInUser; }

      // Else - ask the server
      const user = await Api.get('whoami');
      store.commit('setLoggedIn', user);
      return user;
    },

    async login(store, body) {
      let response = await Api.post("login", body).catch(console.warn)
      store.commit('setLoggedIn', response);
      return response;
    },

    async mustChangePassword() {
      return await Api.get("must-change-password");
    },

    async changePassword(store, body) {
      return await Api.post("change-password", body);
    },

    async logout(store) {
      const response = await Api.get("logout");
      store.commit('setLoggedIn', false);
      return response;
    }
  }
}
